@if (showImage()) {
  <img [src]="imageUrl()" alt="FourEnergy" class="relative z-5 w-full p-2 backdrop-blur-xs border-x border-gray-200/50 backdrop-blur-xs bg-white/80 px-10 max-h-14" />
}
